import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { fetchHomeDisplayConfig } from '@/api/member';

export default function CreatorCenterBanner({ desktopOnly = false }: { desktopOnly?: boolean }) {
  const navigate = useNavigate();
  const { t } = useTranslation('cinema');
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    void fetchHomeDisplayConfig()
      .then((config) => setEnabled(config.creatorCenterEnabled !== false))
      .catch(() => setEnabled(false));
  }, []);

  if (!enabled) return null;

  return (
    <section className={desktopOnly ? 'hidden lg:block px-10 lg:px-14' : ''} aria-label={t('cinema_creatorCenter')}>
      <div className="relative overflow-hidden rounded-2xl border border-background-800/60">
        <img
          src="https://readdy.ai/api/search-image?query=Creative%20cinematic%20banner%20with%20warm%20amber%20and%20golden%20light%20film%20reels%20and%20story%20frames%20floating%20over%20a%20deep%20dark%20elegant%20backdrop%2C%20artistic%20filmmaker%20atmosphere%2C%20soft%20glowing%20bokeh%20and%20premium%20gradient%2C%20inspiring%20creative%20energy%2C%20luxurious%20color%20grading%2C%20high%20detail%2C%20no%20text%2C%20no%20people&width=1400&height=360&seq=creator-entry-banner-v2&orientation=landscape"
          alt=""
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/95 via-background-950/75 to-background-950/30" />
        <div className="relative flex flex-col gap-4 p-5 sm:flex-row sm:items-center md:p-6">
          <div className="min-w-0 flex-1">
            <div className="mb-1 flex items-center gap-2">
              <i className="ri-movie-2-line text-accent-400" />
              <h3 className="text-base font-bold text-foreground-50 md:text-lg">{t('cinema_creatorEarnBannerTitle')}</h3>
            </div>
            <p className="text-xs leading-relaxed text-foreground-400 md:text-sm">{t('cinema_creatorEarnBannerDesc')}</p>
          </div>
          <button type="button" onClick={() => navigate('/creator-center')} className="inline-flex shrink-0 items-center justify-center gap-1.5 rounded-full bg-accent-500 px-5 py-2.5 text-xs font-semibold text-background-950 transition-colors hover:bg-accent-400">
            {t('cinema_creatorEarnBannerBtn')}<i className="ri-arrow-right-line" />
          </button>
        </div>
      </div>
    </section>
  );
}
